import React from 'react';
import { Box } from '@mui/material';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import { COLOR_PRIMARY_2 } from 'src/utils/colors';

const MarketPointer = ({
  lat,
  lng,
  name,
  value,
  url,
  rank,
}: {
  lat: number;
  lng: number;
  name: string;
  value: string;
  url?: string;
  rank?: number;
}) => {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '200px',
        backgroundColor: 'white',
        color: COLOR_PRIMARY_2,
        fontWeight: 'bold',
        borderRadius: '200px',
        display: 'flex',
        flexWrap: 'nowrap',
        justifyContent: 'center',
        alignItems: 'center',
        transform: 'translate(-50%, -50%)',
        boxShadow: '0 2px 4px #0002',
        overflow: 'hidden',
        padding: '10px',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        '&:hover': {
          backgroundColor: COLOR_PRIMARY_2,
          color: 'white',
        },
      }}
      onClick={() => url && window.open(url, '_blank')}
    >
      <Box
        component="span"
        sx={{
          display: 'flex',
          alignItems: 'center',
          whiteSpace: 'nowrap',
          minWidth: 0,
          flex: 1,
        }}
      >
        {rank && (
          <Box component="span" sx={{ flexShrink: 0, mr: 1 }}>
            #{rank}
          </Box>
        )}
        <Box
          component="span"
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            minWidth: 0,
            flex: 1,
          }}
        >
          {name}
        </Box>
        <Box component="span" sx={{ flexShrink: 0 }}>
          ({value})
        </Box>
      </Box>
      <OpenInNewRoundedIcon fontSize="small" sx={{ ml: 1, flexShrink: 0 }} />
    </Box>
  );
};

export default MarketPointer;
